<template>
  <div class="migalhas" v-if="perfil_usuario!=''" id="migalhas">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb" style="padding: 0.35rem 1rem;">
            <li v-if="perfil_usuario==1" class="breadcrumb-item active" aria-current="page"><b>{{ titulo }}</b></li>
            <li v-else-if="perfil_usuario==2" class="breadcrumb-item active" aria-current="page"><b>{{ titulo }}</b></li>
            <li v-else-if="perfil_usuario==3" class="breadcrumb-item active" aria-current="page"><b>{{ titulo }}</b></li>
            <li v-else-if="perfil_usuario==100" class="breadcrumb-item active" aria-current="page"><b>{{ titulo }}</b></li>
            <li v-else class="breadcrumb-item active" aria-current="page"><b> OPS</b></li>
            <li v-if="(perfil_usuario==1 || perfil_usuario==2 || perfil_usuario==3) && quantidadeUnidades!==0" class="breadcrumb-item migalhas__unidade">
                <seletor-unidade variante="barra" @carregado="quantidadeUnidades=$event.length"></seletor-unidade>
            </li>
        </ol>
    </nav>
  </div>
</template>

<script>
import SeletorUnidade from './Unity/SeletorUnidade.vue'

export default {
    components:{ SeletorUnidade },
    props:['titulo','perfil_usuario'],
    data(){
        return{
            quantidadeUnidades:null
        }
    },
}
</script>

<style>
    .migalhas{
        padding-bottom: 0px;
    }

    .migalhas__unidade{
        display: flex;
        align-items: center;
        min-width: 0;
    }

    @media(max-width:600px){
        .migalhas{
            padding-bottom: 5px;
        }   
    }
</style>